import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import styles from "./dropdown.module.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { getLessons, getLessonsForLearnMode } from "../../../api/requests";
import useTranslation from "next-translate/useTranslation";
import ButtonLoading from "../../buttonLoading";
import TokenError from "../../modals/tokenError";
import Layout from "../../sidebarPro";

var DropdownGetBooks = function DropdownGetBooks(_ref) {
  var classes = _ref.classes,
      defaultSelected = _ref.defaultSelected,
      data = _ref.data,
      setLessons = _ref.setLessons,
      setValidated = _ref.setValidated,
      setSelectedBook = _ref.setSelectedBook,
      selectedBook = _ref.selectedBook,
      mode = _ref.mode,
      setError = _ref.setError,
      setShow = _ref.setShow,
      gameFirstTimeUser = _ref.gameFirstTimeUser,
      setGameFirstTimeUser = _ref.setGameFirstTimeUser,
      getBooksLoading = _ref.getBooksLoading,
      setGetLessonsLoading = _ref.setGetLessonsLoading,
      setShow2 = _ref.setShow2;

  var _useState = useState(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var _useState2 = useState(''),
      firstTimeUser = _useState2[0],
      setFirstTimeUser = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    setFirstTimeUser(gameFirstTimeUser);
  }, [gameFirstTimeUser]);
  useEffect(function () {
    if (mode === 'test') {
      var gameFirstTimeUserConst = localStorage.getItem('gameFirstTimeUser');

      if (!gameFirstTimeUserConst || gameFirstTimeUserConst !== '4') {
        localStorage.setItem('gameFirstTimeUser', 0);
        gameFirstTimeUserConst = 0;
        setGameFirstTimeUser(gameFirstTimeUserConst);
      }
    } else if (mode === 'learn') {
      var learnFirstTimeUserConst = localStorage.getItem('learnFirstTimeUser');

      if (!learnFirstTimeUserConst || learnFirstTimeUserConst !== '4') {
        localStorage.setItem('learnFirstTimeUser', 0);
        learnFirstTimeUserConst = 0;
        setGameFirstTimeUser(learnFirstTimeUserConst);
      }
    }
  }, []);

  var toggle = function toggle() {
    var Username = localStorage.getItem('Username');

    if (Username) {
      setDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      setError(["login", false]);
      setShow(true);
    }
  };

  useEffect(function () {
    setSelectedBook({
      code: null,
      name: isRTL ? defaultSelected.fa : defaultSelected.en
    });
  }, [isRTL]);

  var handleSelect = function handleSelect(selectedItem) {
    setGetLessonsLoading(true);
    setSelectedBook({
      code: selectedItem.item.GroupCodeId,
      name: selectedItem.item.AbvName
    });
    setValidated(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        book: true
      });
    });
    var Counter = localStorage.getItem('Counter');
    var token = localStorage.getItem('token');

    if (mode === 'learn') {
      var learnFirstTimeUserConst = localStorage.getItem('learnFirstTimeUser');

      if (learnFirstTimeUserConst !== '4') {
        setGameFirstTimeUser(2);
        localStorage.setItem('learnFirstTimeUser', 2);
      }

      getLessonsForLearnMode(selectedItem.item.GroupCodeId, token).then(function (res) {
        if (Array.isArray(res.data)) {
          setLessons(res.data);
          setGetLessonsLoading(false);
        }
      })["catch"](function (err) {
        var _err$response, _err$response2;

        if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401 || (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status) === 403) {
          localStorage.setItem('token', '');
          localStorage.setItem('Username', '');
          localStorage.setItem('Counter', '');
          localStorage.setItem('isLogin', '');
          localStorage.setItem('CellPhoneNum', '');
          setShow2(true);
        } else {
          console.log("getLessons error:", {
            err: err
          });
        }
      });
    } else {
      var gameFirstTimeUserConst = localStorage.getItem('gameFirstTimeUser');

      if (gameFirstTimeUserConst !== '4') {
        setGameFirstTimeUser(2);
        localStorage.setItem('gameFirstTimeUser', 2);
      }

      getLessons(selectedItem.item.GroupCodeId, token).then(function (res) {
        if (res) {
          if (Array.isArray(res === null || res === void 0 ? void 0 : res.data)) {
            setLessons(res.data);
            setGetLessonsLoading(false);
          } else alert('error: Data is not an array');
        } else alert('error: Did not receive res from api');
      })["catch"](function (err) {
        var _err$response3, _err$response4;

        if ((err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.status) === 401 || (err === null || err === void 0 ? void 0 : (_err$response4 = err.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.status) === 403) {
          localStorage.setItem('token', '');
          localStorage.setItem('Username', '');
          localStorage.setItem('Counter', '');
          localStorage.setItem('isLogin', '');
          localStorage.setItem('CellPhoneNum', '');
          setShow2(true);
        } else {
          console.log("getLessons error:", {
            err: err
          });
        }
      });
    }
  };

  console.log("getBooksLoading", getBooksLoading);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [firstTimeUser == 1 && /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.toolTip, " ").concat(isRTL ? '' : styles.toolTipEn),
      children: /*#__PURE__*/_jsx("p", {
        className: "".concat(styles.toolTipText, " ").concat(isRTL ? '' : styles.toolTipTextEn),
        children: t('start:Choose the book you want to play')
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Dropdown, {
        className: "".concat(styles.menuItem, " ").concat(classes.bg),
        isOpen: dropdownOpen,
        toggle: toggle,
        children: [/*#__PURE__*/_jsx(DropdownToggle, {
          caret: true,
          children: getBooksLoading ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ButtonLoading, {}), /*#__PURE__*/_jsx("span", {
              children: "loading"
            })]
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: selectedBook.name
          })
        }), /*#__PURE__*/_jsx(DropdownMenu, {
          children: data && data.length > 0 ? data.map(function (item, index) {
            return /*#__PURE__*/_jsx(DropdownItem, {
              onClick: function onClick() {
                return handleSelect({
                  item: item,
                  id: index + 1
                });
              },
              children: isRTL ? item.PersianName : item.AbvName
            }, index);
          }) : /*#__PURE__*/_jsx(DropdownItem, {
            children: isRTL ? 'یک مرحله انتخاب کنید' : 'Choose a level'
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classes.arrow
    })]
  });
};

export default DropdownGetBooks;